import { Component, Input, OnInit } from '@angular/core';
import { I18ConfigService } from 'src/app/services/shared/I18-config.service';
import { ActionSheetController, ActionSheetButton } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
@Component({
  selector: 'translation',
  templateUrl: './translation.component.html',
  styleUrls: ['./translation.component.scss'],
})
export class TranslationComponent implements OnInit {
  @Input() currency: any;
  @Input() language: any;
  selectedCurrency: string;
  selectedLanguage: string;
  actionSheetCurrencyButton: any;
  actionSheetLanguageButton: any;
  private actionSheetCurrencyButtonList: ActionSheetButton[] | null = null;
  private actionSheetLanguageButtonList: ActionSheetButton[] | null = null;
  constructor(
    private i18ConfigService: I18ConfigService,
    private actionSheetController: ActionSheetController,
    private translate: TranslateService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    this.selectedCurrency = this.i18ConfigService.getCurrency();
    this.selectedLanguage = this.i18ConfigService.getLanguage();
    if (this.currency) {
      this.createCurrencyButton();
    }
    if (this.language) {
      this.createLanguageButton();
    }
  }
  createCurrencyButton() {
    this.actionSheetCurrencyButtonList = [];
    this.currency.forEach((element) => {
      const obj = {
        text: element?.code + ' - ' + element?.name,
        role: '',
        handler: () => {
          this.i18ConfigService.setCurrency(element?.code);
          this.analyticsService.trackUnified('currency_selected', {
            flow: 'shared',
            outcome: 'success',
            legacy_event_name: 'currency_clicked',
            component: 'translation-component',
            button: 'currency-button',
            currency: element?.code,
          });
          this.selectedCurrency = element?.code;
        },
      };
      if (this.selectedCurrency === element?.code) {
        obj.role = 'selected';
      }
      const actionSheetButton: ActionSheetButton = obj;
      this.actionSheetCurrencyButtonList.push(actionSheetButton);
    });

    this.actionSheetCurrencyButtonList = [
      ...this.actionSheetCurrencyButtonList,
      {
        text: this.translate.instant('translation.cancel'),
        role: 'cancel',
        handler: () => {},
      },
    ];
  }
  createLanguageButton() {
    this.actionSheetLanguageButtonList = [];
    this.language.forEach((element) => {
      const obj = {
        text: element?.code + ' - ' + element?.name,
        role: '',
        handler: () => {
          this.i18ConfigService.setLanguage(element?.code);
          this.analyticsService.trackUnified('language_selected', {
            flow: 'shared',
            outcome: 'success',
            legacy_event_name: 'language_clicked',
            component: 'translation-component',
            button: 'language-button',
            language: element?.code,
          });
          this.selectedLanguage = element?.code;
        },
      };
      if (this.selectedLanguage === element?.code) {
        obj.role = 'selected';
      }
      const actionSheetButton: ActionSheetButton = obj;
      this.actionSheetLanguageButtonList.push(actionSheetButton);
    });

    this.actionSheetLanguageButtonList = [
      ...this.actionSheetLanguageButtonList,
      {
        text: this.translate.instant('translation.cancel'),
        role: 'cancel',
        handler: () => {},
      },
    ];
  }

  async presentCurrencyModal() {
    this.analyticsService.trackUnified('currency_modal_opened', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'currency_clicked',
      component: 'translation-component',
      button: 'currency-button',
    });
    this.createCurrencyButton();
    const actionSheet = await this.actionSheetController.create({
      header: this.translate.instant('translation.change_currency'),
      cssClass: 'custom-sheet',
      buttons: this.actionSheetCurrencyButtonList,
    });
    await actionSheet.present();
  }
  async presentLanguageModal() {
    this.analyticsService.trackUnified('language_modal_opened', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'language_clicked',
      component: 'translation-component',
      button: 'language-button',
    });
    this.createLanguageButton();
    const actionSheet = await this.actionSheetController.create({
      header: this.translate.instant('translation.change_language'),
      cssClass: 'custom-sheet',
      buttons: this.actionSheetLanguageButtonList,
    });
    await actionSheet.present();
  }
  handleTranslationAction() {
    this.analyticsService.trackUnified('translation_clicked', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'translation_clicked',
      component: 'translation-component',
      button: 'translation-button',
    });
  }
}
